import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type { BookListItem, BookDetail, BookProgress } from "@/types/book";

export function useBooks(options?: { enabled?: boolean }) {
  return useQuery<BookListItem[]>({
    queryKey: ["books"],
    queryFn: () => apiFetch<BookListItem[]>("/books"),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
  });
}

export function useBook(id: number) {
  return useQuery<BookDetail>({
    queryKey: ["book", id],
    queryFn: () => apiFetch<BookDetail>(`/books/${id}`),
    enabled: !!id,
    staleTime: 60 * 1000,
  });
}

export function useStartBookProgress() {
  const queryClient = useQueryClient();
  return useMutation<BookProgress, Error, number>({
    mutationFn: (bookId) =>
      apiFetch<BookProgress>(`/books/${bookId}/start-progress`, {
        method: "POST",
      }),
    onSuccess: (_, bookId) => {
      queryClient.invalidateQueries({ queryKey: ["book", bookId] });
      queryClient.invalidateQueries({ queryKey: ["books"] });
    },
  });
}
